<template>
    <article class="execution-step">
        <a v-if="link && link.url" :href="link.url" class="execution-step__link">
            {{ link.text }}
        </a>
    </article>
</template>

<script>
export default {
    name: 'Bank',

    props: {
        link: {
            type: Object,
            required: true,
        },
    },
    computed: {
        orderStepString() {
            return this.orderNumber < 10 ? '0' + this.orderNumber : this.orderNumber;
        }
    }
}
</script>

<style scoped lang="scss">
.execution-step {
    $border-radius-desktop: $border-radius-default;
    $padding-desktop: $gap-medium;

    overflow: hidden;

    height: 100%;
    padding: 0 15px;
    border: solid 1px $bondi-blue;

    border-radius: rem($border-radius-desktop);
    background-color: $color-card-background-primary;
    &:hover {
        background-color: $bondi-blue;
        color: $white;
    }
    &__header {
        @include flex-space-between;

        &-icon {
            color: $primary;
        }
    }

    &__order-number {
        @include text-xl;

        color: $color-text-muted-high;

        @media #{$screen-big} {
            font-size: rem($font-size-large);
        }
    }

    &__title {
        @include text-medium($font-weight-bold, $line-height-large);

        margin: rem($gap-normal) 0;

        @media #{$screen-big} {
            font-size: rem($font-size-normal);
        }
    }

    &__description {
        height: 110px;
        @include text-normal;

        @media #{$screen-big} {
            font-size: rem($font-size-small);
        }
    }
    &__link {
        text-decoration: none;
        @include text-normal( $line-height-large);
        
    }
}
</style>